<template>
  <div class="story">
    
    <div class="vrijLogo" :style="{ left: slideSide + 'px'}"><p class="vrij">Vrij!</p></div>
    <Lintje class="menu" :kaart="false" :minimap="minimap"/>
    <Mapbox :interactive="false"/>
    <MaandSlider class="slider" :style="{ left: slideSide + 'px'}"/>
    <div id="storyScroller" v-on:scroll="handleScroll">
      <Content v-for="story in stories" :key="story.id" :story="story"/>
      <div class="goToKaart calltoaction" @click="selectMap" :title="title">
        <img src="/img/button_kaart.png" title="Ga naar de kaart"/>
        <div class="kaartText"><span>{{title}}</span></div>
      </div>
      <div class="goBackStory calltoaction" @click="goBack" :title="titleback" :style="{backgroundImage: maandImage}">
        <p>{{titleback}}</p>
      </div>
    </div>
  </div>
</template>
<style scoped>

.vrijLogo {
  position: fixed;
  transition: left 500ms ease-in-out;
  z-index: 20000;
  margin: 10px;
}

.vrijLogo .vrij {
  font-family: BornReady, Arial, Helvetica, sans-serif;
  color: #f18e05;
  font-size: 60px;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  margin: 0;
}

.story {
  padding: 0;
  margin: 0;
  height: 100vh;
}
.menu {
  right: 120px;
  position: fixed;
  z-index: 10002;
}
.slider {
  position: fixed;
  transition: left 500ms ease-in-out;
  z-index: 10000;
  top: calc(50vh - 270px);
}
#storyScroller {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.goToKaart {
  display:flex;
  flex-direction: column;
  padding: 90px 5px 5px 5px;
  font-family: RijksoverheidSansText;
  font-size: 28px;
  line-height: 29px;
  color: #7897B5;
  align-items: center;
}

.kaartText {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  background: #F0EEEA;
  height:120px;
  max-height: 120px;
  width: 288px;
  margin-top:-50px;
  z-index:-1;
}

.kaartText span {
  margin: 5px 30px
}

.goBackStory {
  padding: 5px 5px 5px 5px;
  font-Family: RijksoverheidSansText;
  font-Style: Bold;
  font-Size: 28px;
  min-width: 288px;
  min-height:218px;
  margin-bottom: 40px;
}

.goBackStory p {
  margin:10px 30px ;
  color: #34352D;
}

.calltoaction {
  font-weight: bold;
  width: 208px;
  margin-bottom: 100px;
  pointer-events: all;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center 10px;
  -ms-flex-item-align: center;
  align-self: center;
}

@media (min-width: 768px) {
  .menu {
    right: 145px;
  }
}
</style>

<script>
/**
  De view voor maand/verhaal met het verhaal van die maand
*/
import Mapbox from "../components/Mapbox.vue";
import MaandSlider from "../components/MaandSlider.vue";
import Content from "../components/Content.vue";
import Lintje from "../components/Lintje.vue";

function isElementOnScreen(el, center) {
  let bounds = el.getBoundingClientRect();

  return bounds.top - 50 < center && bounds.bottom + 50 > center;
}

export default {
  name: "Story",
  data() {
    return {
      slideSide: -100,
      onScreen: "hfst0",
      minimap: false
    };
  },
  computed: {
    month() {
      return this.$store.state.currentMonth;
    },
    stories() {
      return this.$store.state.config.stories;
    },
    title() {
      return `Verken de interactieve kaart`;
    },
    titleback() {
      return `Beleef het verhaal van ${this.$route.params.month} opnieuw`;
    },
    maandImage() {
      return `url("/${this.$route.params.month}/button_verhaal.png")`
    }
  },
  components: {
    Mapbox,
    MaandSlider,
    Content,
    Lintje
  },
  methods: {
    handleScroll(e) {
      let s = e.target.scrollTop,
        c = e.target.clientHeight;
      let elOnScreen;
      e.target.childNodes.forEach(element => {
        if (isElementOnScreen(element, c / 2)) elOnScreen = element;
      });

      if (elOnScreen && this.onScreen !== elOnScreen.id) {
        this.onScreen = elOnScreen.id;
        let name = this.$route.name;
        let maand = this.$route.params.month;
        this.$router.push({
          name: name,
          params: { month: maand },
          hash: `#${this.onScreen}`
        });
        this.$store.commit("config/setActiveStory", this.onScreen);
      }
      if (s > c && this.slideSide !== 0) {
        this.minimap = true;
        this.slideSide = 0;
      }
      if (s < c && this.slideSide !== -100) {
        this.minimap = false;
        this.slideSide = -100;
      }
    },
    selectMap: function() {
      let params = this.$route.params;
      this.$router.push({ name: "kaart", params: params });
    },
    goBack: function() {
      this.$scrollTo("#hfst0", {
        container: "#storyScroller",
        offset: -200,
        easing: "ease-in-out"
      });
    }
  },
  beforeCreate: function() {
    this.$store.dispatch("config/getMonth", this.$route.params.month);
  },
  mounted: function() {
    if (this.$route.hash && this.$route.hash.indexOf("/") === -1) {
      this.$scrollTo(this.$route.hash, {
        container: "#storyScroller",
        offset: -200,
        easing: "ease-in-out"
      }); //TODO: offset veranderen zodat text altijd in het midden komt
    }
  }
};
</script>